// src/hooks/portfolio/usePortfolioPerformanceVsBenchmark.ts

import { useQuery } from "@tanstack/react-query";
import { portfolioPerformanceVsBenchmarkQueryOptions } from "@/services/queries/portfolioQueries";

export const usePortfolioPerformanceVsBenchmark = (authToken?: string) => {
  return useQuery(portfolioPerformanceVsBenchmarkQueryOptions(authToken));
};


